import { Vector2, Vector3, Color } from 'three';
export const TEXTURE_SCHEMA = {
    offset: { kind: 'vector2', requiresNeedsUpdateOnChange: false },
    repeat: { kind: 'vector2', requiresNeedsUpdateOnChange: false },
    center: { kind: 'vector2', requiresNeedsUpdateOnChange: false },
    rotation: { kind: 'number', requiresNeedsUpdateOnChange: false },
    mapping: { kind: 'enum', requiresNeedsUpdateOnChange: true },
    wrapS: { kind: 'enum', requiresNeedsUpdateOnChange: true },
    wrapT: { kind: 'enum', requiresNeedsUpdateOnChange: true },
    magFilter: { kind: 'enum', requiresNeedsUpdateOnChange: true },
    minFilter: { kind: 'enum', requiresNeedsUpdateOnChange: true },
    anisotropy: { kind: 'number', requiresNeedsUpdateOnChange: true },
    format: { kind: 'enum', requiresNeedsUpdateOnChange: true },
    type: { kind: 'enum', requiresNeedsUpdateOnChange: true },
    colorSpace: { kind: 'enum', requiresNeedsUpdateOnChange: true },
    generateMipmaps: { kind: 'boolean', requiresNeedsUpdateOnChange: true },
    matrixAutoUpdate: { kind: 'boolean', requiresNeedsUpdateOnChange: false },
    flipY: { kind: 'boolean', requiresNeedsUpdateOnChange: true },
    premultiplyAlpha: { kind: 'boolean', requiresNeedsUpdateOnChange: true },
    unpackAlignment: { kind: 'number', requiresNeedsUpdateOnChange: true },
};
export function convertTextureValue(kind, value) {
    if (value == null)
        return value;
    switch (kind) {
        case 'vector2': {
            if (value instanceof Vector2)
                return value;
            if (Array.isArray(value))
                return new Vector2(value[0], value[1]);
            return new Vector2(value.x, value.y);
        }
        case 'vector3': {
            if (value instanceof Vector3)
                return value;
            if (Array.isArray(value))
                return new Vector3(value[0], value[1], value[2]);
            return new Vector3(value.x, value.y, value.z);
        }
        case 'color':
            return new Color(value);
        default:
            return value;
    }
}
//# sourceMappingURL=TextureSchema.js.map